import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react";
import PodStatusSpinner, { PodStatusSpinnerState } from "../PodStatusSpinner";

interface Props {
  show: boolean,
  name: string,
  loading?: boolean,
  onConfirm: () => void,
  onCancel: () => void,
}

const RemoveProviderDialog = ({show, name, loading, onConfirm, onCancel}: Props) => (
    <Dialog
      hidden={!show}
      dialogContentProps={{
        title: "Remove provider",
      }}
    >
      <div style={{ minHeight: '43px' }}>
        Are you sure you want to remove {name}?
      </div>
      <DialogFooter styles={{ actions: { lineHeight: 'unset' } }}>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          marginRight: '4px',
        }}>
          { loading && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <PodStatusSpinner state={PodStatusSpinnerState.loading} />
            </div>
          )}
          <PrimaryButton onClick={onConfirm} disabled={loading}>
            {loading ? 'Removing...' : 'Remove'}
          </PrimaryButton>
          <DefaultButton onClick={onCancel} disabled={loading}>Cancel</DefaultButton>
        </div>
      </DialogFooter>
    </Dialog>
);

export default RemoveProviderDialog;